import type {
	Components,
} from '@mui/material'
import {
	speedDialActionClasses,
} from '@mui/material'

export const materialUISpeedDialTheme: {
	components: Components
} = {
	components: {
		MuiSpeedDial: {
			styleOverrides: {
				root: {
					[`.${speedDialActionClasses.staticTooltipLabel}`]: {
						backgroundColor: 'var(--secondary-color)',
						padding:         'var(--base-spacing-1) var(--base-spacing-2)',
						fontSize:        'var(--font-size-body-xxl-small)',
						color:           'var(--on-secondary-color)',
						fontWeight:      500,
						lineHeight:      1,
						boxShadow:       'var(--base-box-shadow)',
					},
				},
				fab: {
					width:           '3rem',
					height:          '3rem',
					flex:            '0 0 3rem',
					backgroundColor: 'var(--secondary-color)',
					boxShadow:       'var(--base-box-shadow)',
					border:          '2px solid var(--outline-color-base)',

					'&:hover': {
						backgroundColor: 'var(--secondary-color-hover)',
					},
				},
				actions: {
					[`& .${speedDialActionClasses.fab}`]: {
						backgroundColor: 'var(--secondary-color)',

						'&:hover': {
							backgroundColor: 'var(--secondary-color-hover)',
						},
					},
				},
			},
		},
	},
}
